import { Injectable } from "@angular/core";

export enum EventTypes {
    ButtonClick = "button_click"
}

@Injectable()
export class GoogleAnalyticsService {
    
    constructor() {
        // Suppress errors if the Google Analytics script has not been enabled
        if (!(<any>window).gtag) {
            (<any>window).gtag = function() {};
        }
    }

    public logButtonClick(buttonName: string) {
        this.logEvent(EventTypes.ButtonClick, { 'name': buttonName });
    }

    private logEvent(eventType: string, params: object) {
        (<any>window).gtag('event', eventType, params);
    }
}
